//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
        /*
         * dragSortItem is a helper directive for 'dragSort' which wraps jquery ui's sortable functionality (http://api.jqueryui.com/sortable)
         *
         * @attr item           the object representing this element's sortable item
         * @attr dragIndex      an id used to connect the DOM element to the item
         */
        .directive('dragSortItem', () => ({
          restrict: 'C',
          scope: {
            item: '=',
            dragIndex: '@',
          },
          require: '^dragSort',
          link(scope, element, attrs, dragSort) {
            scope.item.dragIndex = scope.dragIndex;
            dragSort.registerItem(scope.item);
          },
        }));
})();
